export default {
  title: 'עמלות סוכנות',
  action: 'הוסף עמלות סוכנות',
  fileTitle: 'עמלות סוכנות',
  verifyDeletion: 'האם אתה בטוח שברצונך להעביר את עמלת הסוכנות לארכיון?',
  deletionReason: 'סיבת המחיקה',
  succesdDelete: 'עמלת סוכנות הועברה לארכיון בהצלחה',
  faildDelete: 'לא ניתן להעביר את עמלת הסוכנות לארכיון אנא נסה שנית',
  notification: {
    errors: {
      find: {
        title: 'שגיאה',
        message: 'לא ניתן למצוא עמלות סוכנות אנא נסה שנית',
      },
      delete: {
        title: 'שגיאה',
        message: 'לא ניתן למחוק עמלות סוכנות אנא נסה שנית',
      },
      export: {
        title: 'שגיאה',
        message: 'לא ניתן להפיק דו"ח אנא נסה שנית',
      },
    },
  },
};
